// plugins/vuetify.js
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { zhHant, zhHans, ja, en, th } from 'vuetify/locale'
import { CUSTOM_COLORS, FUNNOW_BREAKPOINTS } from '@/constants/theme'

// import polyfills to support older browsers
import 'core-js/actual/array/at'

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    // ssr: nuxtApp.ssrContext?.noSSR === false,
    ssr: true,
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
    display: {
      mobileBreakpoint: 600,
      thresholds: FUNNOW_BREAKPOINTS,
    },
    theme: false,
    // theme: {
    //   themes: {
    //     light: {
    //       dark: false,
    //       colors: CUSTOM_COLORS,
    //       variables: {
    //         'theme-on-orange30': '255,255,255',
    //       },
    //     },
    //   },
    // },
    locale: {
      locale: 'en',
      fallback: 'en',
      messages: {
        'zh-tw': zhHant,
        'zh-cn': zhHans,
        ja,
        en,
        th,
      },
    },
  })
  const locale = (<any>nuxtApp.$i18n).locale.value
  vuetify.locale.current.value = locale
  if (nuxtApp._vuetify) return
  nuxtApp.vueApp.use(vuetify)
  nuxtApp._vuetify = true
})
